import React, { useRef } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import ButtonElement from "../UiComponents/ButtonElement";
import { mfaGenerate, mfaVerification } from "../../Services/mfsService";
import { getUser, verifyToken } from "../../Services/authService";
import { useCustomerContext } from "../../Providers/CustomerProvider";
import { getCustomer, getLogo } from "../../Services/customerServices";
import { InputOtp } from "primereact/inputotp";
import { Message } from "primereact/message";
import _ from "lodash";
import socket from "../../socket";
import { useLoginPermissionProvider } from "../../Providers/LoginPermissionProvider";

export const Mfa = () => {
  const navigate = useNavigate();
  const {
    customer,
    setCustomerData,
    getCustomerData,
    reloadCustomerData,
    enableTutorials,
  } = useCustomerContext();
  const { setGlobalLoginPermission } = useLoginPermissionProvider();
  const [data, setData] = useState({
    username: "",
    email: "",
  });

  const [userdata, setUserData] = useState({
    isAdmin: "",
    isBranchAdmin: "",
    isRestricted: "",
    acceptGdpr: "",
    curCustomer: "",
    short_name: "",
    currCustomer: "",
  });
  let [countdown, setCountdown] = useState(60);
  const [showInput, setShowInput] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const countdownRef = useRef(countdown);

  useEffect(() => {
    const storedData = localStorage.getItem("enduser");
    if (storedData) {
      const userdata = JSON.parse(storedData);
      var maskedEmail = ''
      if (userdata) {
        if (userdata.email) {
          var atIndex = userdata.email.lastIndexOf('@');
          var maskedPart = userdata.email.slice(0, atIndex - 3);
          var unmaskedPart = userdata.email.slice(atIndex - 3);
          maskedEmail = maskedPart.replace(/./g, '*') + unmaskedPart;
        }
        setEmail(userdata.email)
        setData((prevData) => ({
          ...prevData,
          username: userdata.username,
          email: maskedEmail,
        }));
      } else {
        navigate("/login")
        localStorage.clear()
      }
    }

  }, []);

  /// load PAge ///////////////////////////////////
  const currVersion = "";
  const versions = [];
  const loadPage = async function (currCustomer, currentPage) {
    const customerDAta = await getCustomer(currCustomer);
    if (customerDAta && customerDAta.data) {
      const shortName = customerDAta.data.customer_short;
      if (customerDAta.data.version_maintained.length == 1) {
        currVersion = "v1";
      } else {
        for (var i = 0; i < customerDAta.data.version_maintained.length; i++) {
          if (
            customerDAta.data.version_maintained[i].module_name.toLowerCase() ==
            "dashboard"
          ) {
            versions.push(customerDAta.data.version_maintained[i].version_detail);
          }
        }
        const short_name = userdata.short_name;
        if (currentPage == "Dashboard") {
          navigate(`/dashboard/${shortName}`);
        }
      }
    }
  };
  useEffect(() => {
    // Define the event listener for 'getBrowserId'
    socket.on('getBrowserId', async () => {
      const user = await getUser();
      const isTokenValid = await verifyToken()
      if (user) {
        if (isTokenValid?.success && !_.isEmpty(user.data.uniqid)) {
          // const uuser = JSON.parse(localStorage.getItem("enduser"));
          socket.emit('bindBrowserId', { browserId: user.data.uniqid, customer_id: user.data.customer });
        }
      }
    });
  }, [email]);

  const verifyOTP = async () => {
    // var email = data.email;
    var otp = otpValue;
    var username = data.username;
    const mfaVerificationResponse = await mfaVerification(email, otp, username);
    if (mfaVerificationResponse) {
      if (mfaVerificationResponse.success) {
        setErrorMessage("");
        setMessage(mfaVerificationResponse.message);

        // vm.error = '';
        // vm.processing = false;
        // vm.submitted = false;
        const user = await getUser();
        if (user && user.data) {
          localStorage.setItem("enduser", JSON.stringify(user.data));
          localStorage.setItem(
            "user_privileges",
            JSON.stringify(user.data.user_privileges)
          );
          // const uuser = JSON.parse(localStorage.getItem("enduser"));
          // io.emit('login', { browserId: vm.uuser.uniqid, customer_id: curCustomer });
          // const token = await getToken();
          const currCustomer = user.data.customer;
          // const dashboardFrom = "homePage";
          setUserData((prevdata) => ({
            ...prevdata,
            ["isAdmin"]: user.data.isAdmin,
            ["isBranchAdmin"]: user.data.isBranchAdmin,
            ["acceptGdpr"]: user.data.accept_gdpr,
            ["isRestricted"]: user.data.isRestricted,
            ["curCustomer"]: user.data.customer,
            ["short_name"]: user.data.customer_short,
            ["currCustomer"]: user.data.customer,
          }));
          const isTokenValid = await verifyToken();
          if (isTokenValid.success) {
            if (user.data.accept_gdpr) {
              const customerData = await getCustomer(currCustomer);
              if (customerData && customerData.data) {
                // loadPage(currCustomer, "Dashboard");
                if (user.data.isRestricted) {
                  setGlobalLoginPermission(prevState => ({
                    ...prevState,
                    isAdmin: user.data.isAdmin,
                    isBranchAdmin: user.data.isBranchAdmin,
                    isRestricted: user.data.isRestricted,
                  }));
                  navigate("/portfolio")
                }
                else {
                  setGlobalLoginPermission(prevState => ({
                    ...prevState,
                    isAdmin: user.data.isAdmin,
                    isBranchAdmin: user.data.isBranchAdmin,
                    isRestricted: user.data.isRestricted,
                  }));
                  // navigate(`/dashboard/${shortName}`);
                  loadPage(currCustomer, "Dashboard")
                }
              }
            } else {
              navigate("/acceptGdpr")
            }
          }
        }
      } else {
        setMessage("");
        setErrorMessage(mfaVerificationResponse.message);
      }
    }

  };

  useEffect(() => {
    countdownRef.current = countdown;
  }, [countdown]);

  const startCountdown = () => {
    const intervalId = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown > 0) {
          return prevCountdown - 1;
        } else {
          clearInterval(intervalId);
          setOtpSent(false);
          setCountdown(60);
          setShowInput(true);
          return 60;
        }
      });
    }, 1000);
  };

  //MFA CONTROLLER
  const generateAndSendOTP = async () => {
    if (!otpSent) {
      setOtpSent(true);
      setShowInput(true);
      startCountdown();
      const optGenerate = await mfaGenerate(email, data.username, window.navigator.userAgent)
      if (optGenerate) {
      }
    }
  };

  return (
    <div>
      <div className="mfa-container">
        <div className="emailConatiner">
          {/* <ButtonElement className="pi pi-lock zz"/> */}
          <i className="pi pi-lock lock-icon "></i>
          <h2>Authenticate your account</h2>
          <p>{data.email}</p>
          {!otpSent ? (
            <ButtonElement
              className="sent-otp-button"
              label="Send"
              onClick={generateAndSendOTP}
            />
          ) : (
            <>
              <ButtonElement
                className="resend-otp-button"
                disabled={otpSent}
                label="Resend OTP"
              />
              {countdown} seconds
            </>
          )}
          {showInput ? (
            <div className="verify-input">
              {/* <InputTextElementElement className="verify-input-field" onChange={(e)=>setOtpValue(e.target.value)} placeholder="Enter OTP"/> */}
              <InputOtp
                className="verify-input-field"
                onChange={(e) => setOtpValue(e.value)}
                length={6}
                integerOnly
              />
              <ButtonElement
                className="verify-button"
                label="Verify"
                onClick={verifyOTP}
              />
            </div>
          ) : (
            ""
          )}
          {message && message ? (
            <Message severity="success" text={message} />
          ) : null}
          {errorMessage && errorMessage ? (
            <Message severity="error" text={errorMessage} />
          ) : null}
        </div>
      </div>
    </div>
  );
};
